import { render, staticRenderFns } from "./SectionHeader.vue?vue&type=template&id=d0040336"
import script from "./SectionHeader.vue?vue&type=script&lang=ts"
export * from "./SectionHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0040336')) {
      api.createRecord('d0040336', component.options)
    } else {
      api.reload('d0040336', component.options)
    }
    module.hot.accept("./SectionHeader.vue?vue&type=template&id=d0040336", function () {
      api.rerender('d0040336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CarePlanRightSide/components/SectionHeader.vue"
export default component.exports